import React from 'react';
import moment from 'moment-timezone';
import classNames from 'classnames';
import { FormFieldBase } from '..';
import { styles, StyledSlider } from './styles';
import {
  Labels,
  IPinfo_API,
  Defaults,
  SliderDefaultProp,
  SpecialCharactersRegex,
  EntityTypes,
  activeTabs,
  countryList,
  zipCodeMask,
  noLocationFoundMessage,
  zipCodeValidationMessage,
  zipCodeLabel,
  ZipCodeTextLength,
  noLocationFoundMessageForAppointmentType
} from './constants';
import Api from './api';

import {
  matchFieldByLabel,
  toDaysOfYear,
  arrangeUniqTimeSlots,
  filterTimeSlots,
  sortProviders,
  getZipCodeErrorValidationMessage,
  sortLocations,
  sortLocationsByRadius,
  dateFormat,
  isAvailableSlot,
  filterTimeSlotsByProviderLocation
} from './utils';

import { Tabs, Tab } from '../../../../../Tabs';
import ValidationMessage from '../validation-message';
import AppointmentBookingPlaceholder from './components/appointment-booking-placeholder';
import AppointmentSelector from './components/appointment-selector';
import MultiSelectWrapper from './multi-select-wrapper';
import LocationsList from './location-list';
import { Slider } from '@material-ui/core';

// CSS imports
import './form-field-appointment-booking.scss';

let isSingleAppointmentType = false;
let singleAppointmentTypeName = '';
let isMultiLocation = false;
export class FormFieldAppointmentBooking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appointmentTypes: [],
      appointmentTypeId: Defaults.AppointmentType.id,
      providers: [Defaults.Provider],
      zipCode: '',
      radius: SliderDefaultProp.minRange,
      providerId: Defaults.Provider.id,
      isChangeAppointmentType: false,
      forceRenderDatePicker: true,
      ...this.defaultDateTimeState,
      pointLatitude: '',
      pointLongitude: '',
      locationsList: [],
      locationId: '',
      filteredLocations: [],
      listOfSelectedLocations: [],
      activeTab: props.activeOABTab || activeTabs.radius,
      country: '',
      zipCodeMaskErrorMessage: '',
      zipCodePlaceHolder: '',
      radiusSlider: {
        minRange: SliderDefaultProp.minRange,
        maxRange: SliderDefaultProp.maxRange
      },
      geoLocationList: null,
      locationNotFound: '',
      timeZone: null,
      isRequireMinMax: true,
      isOpenDaysLoading: false,
      isAppointmentDaysLoading: false,
      isGeoLocationRequestCompleted: true,
      timeInterval: props.generalSettingParams.timeInterval ?? null,
      syncAvailability: props.generalSettingParams?.syncAvailability ?? false,
      isAvailProviderCoupled: props.generalSettingParams?.syncAvailability ? props.generalSettingParams?.isAvailProviderCoupled ?? true : true,
      placeholderProviderId: props.generalSettingParams?.placeholderProviderId ?? 0,
    };
  }

  async componentDidMount() {
    // load MultiLocation  setting of account
    const isMultiLocationResponse = await Api.getIsMultiLocation(
      this.accountId
    );
    isMultiLocation = isMultiLocationResponse.isMultiLocation;

    // load countryCode
    await this.loadAccountAddress();
    await this.loadDefaultLocationList(this.state.syncAvailability);

    // load appointment types list
    let appointmentTypes = [];
    if (this.state.syncAvailability) {
      appointmentTypes = await Api.getPddsAppointmentTypes(
        this.accountId,
        this.state.syncAvailability.toString(),
        this.state.isAvailProviderCoupled.toString()
      );
    } else {
      appointmentTypes = await Api.getAppointmentTypes(this.accountId);
    }
    appointmentTypes.unshift(Defaults.AppointmentType);

    if (isMultiLocation) {
      this.getUserLocation();
    }

    this.setState(
      {
        appointmentTypes,
      },
      () => {
        this.handleSingleAppointmentType(appointmentTypes);
        if (this.props.isReview) {
          // true when viewing a submission
          this.loadValues();
        }
    const fields = this.getFieldsByLabel();
    fields[Labels.AppointmentType].timeInterval = this.state.timeInterval;
    fields[Labels.AppointmentType].syncAvailability = this.state.syncAvailability;
    fields[Labels.AppointmentType].accountIdOAB = this.accountId;
    fields[Labels.AppointmentType].timeZone = this.state.timeZone;

      }
    );

    this.handleChange(Labels.Radius, null, false);
    this.handleChange(Labels.ZipCode, '', false);
  }

  componentDidUpdate(prevProps, prevState) {
    // TODO: do we need to account for patient pulling up previous submission?
    // E.g., will they be able to hit the share/microsite link and see their previous appointment request

    if (prevState.radius !== this.state.radius) {
      this.setState({ isRequireMinMax: false }, () => {
        this.getGeoLocation().then(() => {
          this.updateOpenDays();
        });
      });
    }

    if (prevState.appointmentTypeId !== this.state.appointmentTypeId) {
      this.getGeoLocation().then(() => {
        this.updateOpenDays();
      });
    }

    if (!this.props.isReview) return;

    if (this.valuesHaveChanged(prevProps)) {
      this.loadValues();
    }
  }
  componentWillReceiveProps(nextProps) {
  if(nextProps?.oabSubmissionConflictError !== this.props.oabSubmissionConflictError && nextProps?.oabSubmissionConflictError > 0  && this.state.locationId && this.state.virtualCalender?.days){
    const currentSlots = this.state.currentSelectedTimeSlots.filter(c => Number(c.locationId) !== Number(this.state.locationId));
    currentSlots.push(...nextProps.updatedAppointmentBookingSlots);
    const virtualCalender = this.getUpdatedVirtualCalender(currentSlots);
    this.setState({currentSelectedTimeSlots: currentSlots,virtualCalender}, async ()=> {
      if(this.state.locationId && this.state.virtualCalender?.days){
      await this.updateOpenDays(this.state.selectedDay,false);
      await this.updateProvidersOnSelectedDateAndTime(undefined, this.state.locationId);
      }
    });
   }
  }
  loadDefaultLocationList = async (syncAvailability) => {
    // load all location list
    let locationsList = await Api.getLocations(this.accountId);
    if (locationsList) {
      locationsList = sortLocations(locationsList);
      this.setState({ locationsList });
      if (syncAvailability)
        await this.loadDefaultPddsLocationList(locationsList);
      // set all by default
      this.selectAllLocations(locationsList);
      if (isMultiLocation) {
        await this.getUserLocation();
      }
    }
  };

  loadDefaultPddsLocationList = async (locationsList) => {
    // load all location list
    let pddLocationsList = await Api.getPddsLocations(this.accountId);
    if (pddLocationsList) {
      const locations = this.overrideAppointmentTypesOfPdds(
        pddLocationsList,
        locationsList
      );
      this.setState({ locationsList: locations });
    }
  };

  overrideAppointmentTypesOfPdds = (pddsLocationList, locationsList) => {
    locationsList.forEach((location, idx) => {
      const getPddsAppointmentTypes = pddsLocationList.filter(
        (item) => item.id === location.id
      );
      if (getPddsAppointmentTypes.length === 1) {
        location.appointmentTypeIds =
          getPddsAppointmentTypes[0].appointmentTypeIds;
      } else {
        location.appointmentTypeIds = [];
      }
    });
    return locationsList;
  };

  loadAccountAddress = async () => {
    // get address regis ter account
    const registerAddress = await Api.getRegisterAddress(this.accountId);

    const { timezone } = registerAddress;

    if (timezone) this.setState({ timeZone: timezone });

    if (
      registerAddress &&
      registerAddress.postalAddress &&
      registerAddress.postalAddress.country
    ) {
      this.setState({ country: registerAddress.postalAddress.country });
      const zipCodePlaceHolder =
        registerAddress.postalAddress.country == countryList.US
          ? zipCodeLabel.US
          : zipCodeLabel.CA;
      this.setState({ zipCodePlaceHolder });
    }
  };
  handleSingleAppointmentType = (appointmentTypes) => {
    isSingleAppointmentType = appointmentTypes.length == 2;
    if (isSingleAppointmentType) {
      const appointmentTypeId = appointmentTypes[1].id;
      singleAppointmentTypeName = appointmentTypes[1].name;
      this.handleAppointmentTypeChange(appointmentTypeId);
    }
  };
  selectAllLocations = (locationsList) => {
    const listOfSelectedLocations = locationsList.map(
      (location) => `${location.id}`
    );
    if (listOfSelectedLocations && listOfSelectedLocations.length > 0) {
      this.setState({ listOfSelectedLocations });
    }
  };

  getUserLocation = async () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        // User granted location permission, retrieve zip code
        (success) => {
          if (success) {
            this.handleGeolocationSuccess();
          }
        },
        (error) => {
          // If geo location zip code error then load location tab
          this.handleTabChange(this.props.activeOABTab || activeTabs.location);
          
          // User denied location permission or error occurred
          console.log('Error getting user location:', error);
        }
      );
    }
  };

  handleGeolocationSuccess = async () => {
    const locationResponse = await fetch(
      `${IPinfo_API.URL}?token=${IPinfo_API.Token}`
    );
    const locationData = await locationResponse.json();
    if (locationData && locationData.postal) {
      const zipCode = locationData.postal || '';
      const [pointLatitude, pointLongitude] = locationData.loc.split(',');
      this.setState({ zipCode, pointLatitude, pointLongitude });
      this.handleZipCodeValidation(true, zipCode);
      this.getGeoLocation();
    } else this.handleTabChange(activeTabs.location);
  };

  getGeoLocation = async (zipCode = null, isTabChange = false) => {
    let geoLocationList;
    const postCode = zipCode || this.state.zipCode;

    if (
      !isTabChange &&
      this.isValidZipCode(postCode) &&
      this.state.activeTab === activeTabs.radius &&
      isMultiLocation
    ) {
      geoLocationList = await Api.getGeoLocationList(
        this.accountId,
        this.state.pointLatitude,
        this.state.pointLongitude,
        this.state.radius,
        postCode,
        this.state.isRequireMinMax
      );
      this.setState({ geoLocationList }, () => {
        this.updateMinMaxRadius(geoLocationList);
        this.zipCodeValidationErrorMessage(geoLocationList);
        this.setState({ isGeoLocationRequestCompleted: true });
      });
    }
    this.filterEnabledLocations(geoLocationList);
  };

  zipCodeValidationErrorMessage = (geoLocationList) => {
    const zipCodeMaskErrorMessage =
      geoLocationList?.errors && this.state.appointmentTypeId
        ? zipCodeValidationMessage.NO_LOCATION
        : '';
    const locationNotFound =
      this.state.appointmentTypeId && !zipCodeMaskErrorMessage
        ? noLocationFoundMessage
        : '';
    this.setState({
      zipCodeMaskErrorMessage,
      locationNotFound
    });
  };

  updateMinMaxRadius = (geoLocationList) => {
    const zipCodeDistanceMin =
      geoLocationList?.zipCodeDistance?.min == null
        ? 0
        : geoLocationList?.zipCodeDistance?.min;
    if (
      zipCodeDistanceMin >= 0 &&
      geoLocationList?.zipCodeDistance?.max &&
      geoLocationList?.items.length > 0
    ) {
      this.setState({
        radius: zipCodeDistanceMin,
        radiusSlider: {
          minRange: zipCodeDistanceMin,
          maxRange: geoLocationList.zipCodeDistance.max
        }
      });
    }
  };

  filterEnabledLocations = (geoLocationList) => {
    // filter geo locations that are enabled for online booking and configured with appointment type
    let filteredLocations = this.state.locationsList
      ? this.state.locationsList
      : [];

    // Map Radius Locations
    if (this.state.activeTab === activeTabs.radius && isMultiLocation) {
      geoLocationList = geoLocationList || this.state.geoLocationList;
      filteredLocations = [];
      if (
        geoLocationList &&
        geoLocationList.items &&
        this.state.locationsList.length > 0
      ) {
        geoLocationList.items.map((geoLocation) => {
          const [location] = this.state.locationsList.filter(
            (location) => location.id === geoLocation.locationId
          );

          if (location) {
            return filteredLocations.push({
              ...location,
              radius: geoLocation.radius
            });
          }
        });
        filteredLocations = sortLocationsByRadius(filteredLocations);
      }
    }

    // Map Appointment Type
    const selectedAppointmentType = this.state.appointmentTypeId;
    const appointmentTypeIds = selectedAppointmentType
      ? [parseInt(selectedAppointmentType)]
      : this.state.appointmentTypes.map((type) => type.id);
    filteredLocations = filteredLocations.filter((location) =>
      location.appointmentTypeIds?.some(
        (id) => appointmentTypeIds.indexOf(id) >= 0
      )
    );

    // filter location based on if any selected date
    if (this.state.currentSelectedTimeSlots) {
      let providerTimeSlots = this.state.providerId
        ? filterTimeSlots(
            this.state.currentSelectedTimeSlots,
            EntityTypes.provider,
            [parseInt(this.state.providerId)]
          )
        : filterTimeSlots(
            this.state.currentSelectedTimeSlots,
            EntityTypes.provider
          );

      const locationIds = providerTimeSlots.map((slot) => slot.locationId);
      filteredLocations = filteredLocations.filter((location) =>
        locationIds.includes(location.id)
      );
    }

    if (filteredLocations.length === 0) {
      this.setState({
        ...this.defaultDateTimeState,
        currentSelectedTimeSlots: null,
        providers: [Defaults.Provider],
        providerId: null
      });
      this.handleChange(Labels.AppointmentDate, null);
      this.handleChange(Labels.AppointmentTime, null);
      this.handleChange(Labels.Provider, null);
    }

    this.selectAllLocations(filteredLocations);
    this.setState({ filteredLocations });
  };

  updateOpenDays = (selectedDate,isDayClick = true) => {
    if (
      this.state.virtualCalender &&
      this.state.virtualCalender.days &&
      this.state.filteredLocations &&
      this.state.providers
    ) {
      const virtualCalenderDays = this.state.virtualCalender.days;
      const locationIds = this.state.locationId
        ? [parseInt(this.state.locationId)]
        : this.state.filteredLocations.map((location) => location.id);

      const providerTimeSlots = this.filterDaysForSelectedEntity(
        virtualCalenderDays,
        locationIds
      );
      const openDays =
        providerTimeSlots.results.length > 0
          ? providerTimeSlots.results.map((slot) =>
              toDaysOfYear(slot.date, this.state.timeZone)
            )
          : undefined;

      // If selectedDate is set when the tab is changed, check if it is part of
      // openDays in the new tab, if yes persist its state, else make it null

      let selectedDay =
        selectedDate &&
        openDays?.includes(
          toDaysOfYear(moment.tz(selectedDate, this.state.timeZone).toDate())
        )
          ? selectedDate
          : null;
  
      if (selectedDay && isDayClick) this.handleDayClick(selectedDay);

      this.setState({
        forceRenderDatePicker: true,
        openDays,
      });
    }
  };

  handleLocationChange = (locationId) => {
    const listOfSelectedLocations = locationId;
    this.setState({ listOfSelectedLocations });
  };

  valuesHaveChanged = (prevProps) => {
    const { value: prevValue = [] } = prevProps;
    const { value = [] } = this.props;
    let isDiff = false;

    for (let i = 0; i < value.length; i++) {
      isDiff = value[i] !== prevValue[i];
      if (isDiff) return isDiff;
    }

    return isDiff;
  };

  get accountId() {
    return this.props.accountId;
  }

  get defaultDateTimeState() {
    return {
      currentMonth: new Date(),
      selectedDay: null,
      selectedTime: null,
      openDays: [],
      timeSlots: [[], []]
    };
  }

  get selectedAppointmentType() {
    return (
      this.state.appointmentTypes.find(
        (type) => type.id === Number(this.state.appointmentTypeId)
      ) || {}
    );
  }

  loadValues = async () => {
    const { value } = this.props;
    if (!value || (Array.isArray(value) && value.length === 0)) return;

    const fields = this.getFieldsByLabel();

    const appointmentTypeId =
      Number(fields[Labels.AppointmentType].value) ||
      Defaults.AppointmentType.id;

    // load appointmentTypeId to state first, so we can properly lookup in state.appointmentTypes (for duration)
    this.setState({ appointmentTypeId }, async () => {
      // now load rest of data from stored values
      const providerId =
        Number(fields[Labels.Provider].value) || Defaults.Provider.id;
      const appointmentDateString = fields[Labels.AppointmentDate].value;

      const selectedDay = appointmentDateString
        ? new Date(appointmentDateString)
        : null;
      const currentMonth = selectedDay || new Date();
      const selectedTime = fields[Labels.AppointmentTime].value;

      if (appointmentTypeId) await this.loadProviders(appointmentTypeId);
      if (appointmentTypeId) await this.loadOpenDays(currentMonth, providerId);
      if (appointmentTypeId && selectedDay)
        await this.loadTimeSlots(selectedDay, providerId);

      this.setState({
        providerId,
        currentMonth,
        selectedDay,
        selectedTime
      });
    });
  };

  getFieldsByLabel = () => {
    const { fields } = this.props.field;
    return {
      [Labels.ZipCode]: matchFieldByLabel(fields, Labels.ZipCode),
      [Labels.Radius]: matchFieldByLabel(fields, Labels.Radius),
      [Labels.Patient]: matchFieldByLabel(fields, Labels.Patient),
      [Labels.AppointmentType]: matchFieldByLabel(
        fields,
        Labels.AppointmentType
      ),
      [Labels.Provider]: matchFieldByLabel(fields, Labels.Provider),
      [Labels.AppointmentDate]: matchFieldByLabel(
        fields,
        Labels.AppointmentDate
      ),
      [Labels.AppointmentTime]: matchFieldByLabel(
        fields,
        Labels.AppointmentTime
      )
    };
  };

  filterDaysForSelectedEntity = (days, locationIds) => {
    const { timeZone } = this.state;
    const results = [];
    const allCalenderSlots = [];
    if (days)
      days.forEach((data) => {
        let isDateAvailable = filterTimeSlotsByProviderLocation(
          data.timeSlots,
          locationIds
        );
        isDateAvailable = isDateAvailable.filter((slot) =>
          isAvailableSlot(slot.startTime, timeZone)
        );

        if (isDateAvailable.length > 0) {
          results.push(data);
          allCalenderSlots.push(...data.timeSlots);
        }
      });
    return { results, allCalenderSlots };
  };

  getUpdatedVirtualCalender = (updatedDaySlots) => {
    const { timeZone } = this.state;
    const newVirtualCalender = [];
    const days = this.state.virtualCalender.days || []
    if (days && updatedDaySlots?.length > 0)
      days.forEach((data) => {
         let newData = data;
        if(moment.tz(data.date,timeZone).format('YYYY-MM-DD') === moment.tz(this.state.selectedTime,timeZone).format('YYYY-MM-DD')){
          newVirtualCalender.push({timeSlots: [...updatedDaySlots],date:data.date});
        }
        else
        newVirtualCalender.push(newData);
      });
    return {days:newVirtualCalender};
  };

  loadProviders = async (appointmentTypeId) => {
    let providers = await Api.getProviders(
      this.accountId,
      appointmentTypeId,
      this.state.syncAvailability.toString(),
      this.state.isAvailProviderCoupled.toString(),
    );
    providers.unshift(Defaults.Provider);

    this.setState({ providers });
  };

  loadOpenDays = async (month, appointmentTypeId) => {
    this.setState({ isOpenDaysLoading: true, isAppointmentDaysLoading: true });
    const virtualCalender = await Api.getVirtualCalender(
      this.accountId,
      appointmentTypeId || this.state.appointmentTypeId,
      month,
      this.state.syncAvailability.toString(),
      this.state.timeInterval,
      this.selectedAppointmentType.duration,
      this.state.isAvailProviderCoupled.toString(),
      this.state.placeholderProviderId ? this.state.placeholderProviderId : '0'
    );

    this.setState((prev) => ({ ...prev, virtualCalender }));
    this.updateOpenDays();
    this.setState({
      isOpenDaysLoading: false,
      isAppointmentDaysLoading: false
    });
  };

  loadTimeSlots = async (day) => {
    const { timeZone } = this.state;
    const virtualDay = this.state.virtualCalender.days.filter(
      (item) =>
        moment.tz(item.date, timeZone).format(dateFormat) ===
        moment(day).format(dateFormat)
    );

    let timeSlots = virtualDay[0].timeSlots;
    const fullDaytimeSlots = arrangeUniqTimeSlots(
      timeSlots,
      this.state.providerId,
      this.state.timeZone
    );

    // divide slots into am/pm
    const amSlots = fullDaytimeSlots.filter(
      (slot) => moment(slot.time).hour() < 12
    );
    const pmSlots = fullDaytimeSlots.filter(
      (slot) => moment(slot.time).hour() >= 12
    );

    this.setState(
      {
        timeSlots: [amSlots, pmSlots],
        currentSelectedTimeSlots: virtualDay[0].timeSlots
      },
      () => {
        this.filterEnabledLocations();
      }
    );
  };

  createEventTarget = (fieldLabel, value) => ({
    target: {
      id: matchFieldByLabel(this.props.field.fields, fieldLabel).uuid,
      value
    }
  });

  handleAppointmentTypeChange = async (appointmentTypeId) => {
    this.setState({ forceRenderDatePicker: false });
    this.setState(
      {
        appointmentTypeId,
        ...this.defaultDateTimeState,
        currentSelectedTimeSlots: null,
        providers: [Defaults.Provider],
        providerId: null
      },
      () => {
        this.handleMonthChange(new Date());
        this.setState({ forceRenderDatePicker: true });
      }
    );
  
    this.handleChange(Labels.AppointmentType, appointmentTypeId);
    this.handleChange(Labels.AppointmentDate, null);
    this.handleChange(Labels.AppointmentTime, null);
  };

  handleProviderChange = (e) => {
    const providerId = e.target.value;
    this.setState(
      {
        providerId
      },
      () => {
        this.filterEnabledLocations();
      }
    );
    this.handleChange(Labels.Provider, providerId);
  };

  handleGeoLocationApiCall = (zipCode) => {
    this.getGeoLocation(zipCode).then(() => {
      this.updateOpenDays();
    });
  };

  handleZipCodeChange = (e, forceValidation = false) => {
    const zipCode = e.target.value.replace(SpecialCharactersRegex, '');
    if (this.state.zipCode !== zipCode) {
      this.setState(
        {
          zipCode,
          pointLatitude: '',
          pointLongitude: '',
          zipCodeMaskErrorMessage: '',
          locationNotFound: '',
          radius: SliderDefaultProp.minRange,
          isRequireMinMax: true,
          radiusSlider: {
            minRange: SliderDefaultProp.minRange,
            maxRange: SliderDefaultProp.maxRange
          },
          isGeoLocationRequestCompleted: false,
        },
        () => {
          this.handleZipCodeValidation(false, zipCode);
        }
      );
    }

    if (!zipCode) {
      this.setState({
        filteredLocations: [],
        radius: SliderDefaultProp.minRange
      });
    }
  };

  handleRadiusChange = (event, radius, forceValidation = false) => {
    this.setState({
      radius
    });
  };

  handleMonthChange = async (month) => {
    const { selectedTime } = this.state;
    this.resetFields();
    // TODO: confirm whether or not changing month should clear date selection
    this.setState(
      {
        currentMonth: month,
        virtualCalender: null
      },
      () => {
        this.getGeoLocation(null, true).then(async () => {
          await this.loadOpenDays(month, this.state.appointmentTypeId);
        });
      }
    );

    this.handleChange(Labels.AppointmentDate, null);
    this.handleChange(Labels.AppointmentTime, null);
  };

  handleDayClick = (day, modifiers = {}) => {
    const { selectedTime } = this.state;

    if (modifiers.disabled) return;

    this.setState(
      {
        selectedDay: day,
        selectedTime: null,
        providerId: Defaults.Provider.id,
        providers: [Defaults.Provider],
        currentSelectedTimeSlots: null,
        locationId: null
      },
      () => {
        this.loadTimeSlots(day);
      }
    );

    // Update provider on "day" selection
    this.updateProvidersOnSelectedDateAndTime();
    this.handleChange(Labels.AppointmentDate, day);
    this.handleChange(Labels.Provider, null);
    this.handleChange(Labels.Location, null);
    if (selectedTime) {
      // Changing the day cleared the previously selected time, trigger change event to show validation message
      this.handleChange(Labels.AppointmentTime, null);
    }
  };

  updateProvidersOnSelectedDateAndTime = async (time, locationId) => {
    const { timeZone } = this.state;
    // load providers from api
    await this.loadProviders(this.state.appointmentTypeId);

    const currentSlots = this.state.currentSelectedTimeSlots;

    if (currentSlots) {
      let providerIds = [];
      const locationIds = this.state.filteredLocations.map(
        (location) => location.id
      );

      // get all providers within selected day time slots
      let availableSlotsForProviders = filterTimeSlots(
        currentSlots,
        EntityTypes.provider
      );
      if (!isMultiLocation && locationIds.length === 1)
        locationId = locationIds[0];

      // filter location thats available for providers
      availableSlotsForProviders = availableSlotsForProviders.filter((slot) =>
        locationIds.includes(slot.locationId)
      );

      // filter time if single slot selected
      if (time)
        availableSlotsForProviders = availableSlotsForProviders.filter(
          (slot) =>
            moment.tz(slot.startTime, timeZone).format('YYYY-MM-DDTHH:mm') ===
              moment(time).format('YYYY-MM-DDTHH:mm') &&
            slot.locationId === locationId
        );

      providerIds = availableSlotsForProviders.map((slot) => slot.entityId);

      // update providers array based on availability of providers
      let availableProviders = [Defaults.Provider];
      const availableProviderList = this.state.providers.filter((provider) =>
        providerIds.includes(provider.id)
      );
      availableProviders.push(...availableProviderList);
      let defaultProviderId = Defaults.Provider.id;
      if (time && this.state.providerId) {
        // make default selected id in dropdown if single provider available
        const isSelectedIdAvailable = availableProviders.filter(
          (item) => `${item.id}` === this.state.providerId
        );

        const stateProviderId =
          isSelectedIdAvailable.length > 0 ? this.state.providerId : undefined;
        defaultProviderId = stateProviderId;
      }

      if (!this.state.isAvailProviderCoupled) {
        availableProviders = availableProviders.filter(provider => provider.id !== '');
        defaultProviderId = availableProviders[0].id;
      }

      // update state of providers and provider id
      this.setState({
        providerId: defaultProviderId,
        isChangeAppointmentType: false,
        providers: availableProviders
      });
      // make auto selected id if user skip the selection of provider
      this.autoSelectProvider(availableProviders);

      // add provider id in formBuilder field value
      this.handleChange(Labels.Provider, defaultProviderId);
    }
  };

  autoSelectProvider = (availableProvider) => {
    // auto selected ID
    const sortProviderList = sortProviders(
      availableProvider.filter((availableProvider) => availableProvider.id)
    );
    if (sortProviderList.length > 0) {
      const fields = this.getFieldsByLabel();
      fields[Labels.Provider].providerAutoId = sortProviderList[0].id;
    }
  };

  handleTimeClick = async (time, locationId) => {
    this.setState({
      selectedTime: time,
      locationId
    });
    this.updateProvidersOnSelectedDateAndTime(time, locationId);
    // update provider on slot selection
    time = time ? time : null;
    this.handleChange(Labels.AppointmentTime, time);
    this.handleChange(Labels.Location, `${locationId}`);
  };

  handleChange = (fieldLabel, value) => {
    this.props.onChange(
      this.createEventTarget(fieldLabel, value),
      // Force Validation
      true,
      // Override Required
      true
    );
  };

  async validateOABSubmissionConflict() {
    if (this.state.selectedTime) {
      const selectedTime = moment
        .tz(this.state.selectedTime, this.state.timeZone)
        .toDate()
        .getTime();
      const virtualCalender = await Api.getVirtualCalenderByLocation(
        this.accountId,
        this.state.appointmentTypeId,
        selectedTime,
        this.state.syncAvailability.toString(),
        this.state.timeInterval,
        this.state.locationId
      );
      let availableSlotTime = [];
      if (virtualCalender?.days?.length === 1) {
        const slots = virtualCalender.days[0].timeSlots;

        if (this.state.providerId)
          availableSlotTime = slots.filter(
            (s) =>
              s.startTime === selectedTime &&
              s.locationId === this.state.locationId &&
              s.entityId === Number(this.state.providerId)
          );
        else
          availableSlotTime = slots.filter(
            (s) =>
              s.startTime === selectedTime &&
              s.locationId === this.state.locationId
          );
        
        if(availableSlotTime.length === 0){
          const currentSlots = this.state.currentSelectedTimeSlots.filter(c => Number(c.location_id) !== Number(this.state.locationId));
          currentSlots.push(...slots);
        }
         
      }
      return availableSlotTime.length > 0
    }
   return false;
  };

  mapLocationsToMenuItems = (location) => {
    const { id, name, displayName, street, street2, radius } = location;
    return {
      value: `${id}`,
      display: displayName || name,
      disabled: false,
      street: street || street2,
      radius
    };
  };

  getMenuItems = (location) => {
    return location?.map(this.mapLocationsToMenuItems);
  };

  handleTabChange = (tab) => {
    const selectedDate = this.state.selectedDay;
    this.props.handleOabTab(tab);
    if (tab) this.resetFields();
    this.setState({ activeTab: tab,selectedDay:selectedDate }, () => {
      this.getGeoLocation(null, true).then(() => {
        this.updateOpenDays(selectedDate);
      });
    });
  };

  resetFields = () => {
    this.handleChange(Labels.AppointmentDate, null);
    this.handleChange(Labels.AppointmentTime, null);
    this.handleChange(Labels.Provider, null);
    this.handleChange(Labels.Location, null);
    return new Promise((resolve) =>
      this.setState(
        {
          ...this.defaultDateTimeState,
          providerId: Defaults.Provider.id,
          providers: [Defaults.Provider],
          currentSelectedTimeSlots: null,
          locationId: null,
          filteredLocations: []
        },
        resolve
      )
    );
  };

  isValidZipCode = (zipCode) => {
    zipCode = zipCode || this.state.zipCode;
    if (zipCode?.length === 0) return false;
    if (this.state.country === countryList.US && !zipCodeMask.US.test(zipCode))
      return false;
    if (this.state.country === countryList.CA && !zipCodeMask.CA.test(zipCode))
      return false;

    return true;
  };

  handleZipCodeValidation = (blurEvent = true, zipCode) => {
    let postalCode = zipCode;
    let zipCodeMaskErrorMessage = '';
    if (postalCode && this.isValidZipCode(postalCode)) {
      // on blur add space after 3 word
      if (this.state.country === countryList.CA && postalCode.length === 6) {
        const zipCode = postalCode.replace(/^(.{3})(.*)$/, '$1 $2');
        this.setState({
          zipCode
        });
      }
      !blurEvent && this.handleGeoLocationApiCall(postalCode);
    } else {
      zipCodeMaskErrorMessage =
        postalCode?.length > 0
          ? getZipCodeErrorValidationMessage(this.state.country)
          : '';
      blurEvent &&
        this.setState({ zipCodeMaskErrorMessage, geoLocationList: null });
      this.resetFields();
    }
  };

  render() {
    const { field, isRenderedField, readOnly } = this.props;
    
    const {
      appointmentTypes,
      providers,
      providerId,
      openDays,
      selectedDay,
      timeSlots,
      selectedTime,
      appointmentTypeId,
      forceRenderDatePicker,
      currentMonth,
      activeTab,
      filteredLocations,
      locationsList,
      currentSelectedTimeSlots,
      listOfSelectedLocations,
      zipCode,
      activePanels,
      locationNotFound,
      timeZone,
      isOpenDaysLoading,
      isAppointmentDaysLoading,
      isGeoLocationRequestCompleted,
      isAvailProviderCoupled,
    } = this.state;

    const fields = this.getFieldsByLabel();

    if (!isRenderedField) return <AppointmentBookingPlaceholder />;

    const inputContainerClasses = classNames({
      'form-field-input-container': true,
      'read-only': readOnly
    });

    const appointmentTypeField = fields[Labels.AppointmentType];
    const providerField = fields[Labels.Provider];
    const zipCodeField = fields[Labels.ZipCode];
    const radiusField = fields[Labels.Radius];
    const dayPickerField = fields[Labels.AppointmentDate];
    const timeSelectorField = fields[Labels.AppointmentTime];
    const locationField = fields[Labels.Location];

    const changeActivePanels = (ids) => {
      this.setState((prevState) => ({
        activePanels: ids
      }));
    };

    return (
      <div key={field.uuid} style={styles.container}>
        <div className={inputContainerClasses} style={styles.dropdown}>
          <div className="form-field-label primary">{`${Labels.AppointmentType} *`}</div>
          <div className="form-field-input select">
            <div
              className={
                appointmentTypeField.validationMessage
                  ? 'control-group error'
                  : ''
              }
            >
              {isSingleAppointmentType ? (
                <input
                  type="text"
                  readOnly
                  id={appointmentTypeField.uuid}
                  name="appointmentType"
                  className="span30"
                  value={singleAppointmentTypeName}
                ></input>
              ) : (
                <select
                  id={appointmentTypeField.uuid}
                  name="appointmentType"
                  className="span30"
                  value={appointmentTypeField.value}
                  onChange={(e) =>
                    this.handleAppointmentTypeChange(e.target.value)
                  }
                  disabled={readOnly}
                >
                  {appointmentTypes.map((t) => (
                    <option key={`appointmentType-${t.id}`} value={t.id}>
                      {t.name}
                    </option>
                  ))}
                </select>
              )}
              <ValidationMessage
                message={appointmentTypeField.validationMessage}
              />
            </div>
          </div>
        </div>

        <AppointmentSelector
          forceRenderDatePicker={forceRenderDatePicker}
          openDays={openDays}
          selectedDay={selectedDay}
          onMonthChange={this.handleMonthChange}
          onDayClick={this.handleDayClick}
          onTimeClick={this.handleTimeClick}
          dayPickerField={dayPickerField}
          initialMonth={currentMonth}
          readOnly={readOnly}
          isOpenDaysLoading={isOpenDaysLoading}
          isAppointmentDaysLoading={
            isAppointmentDaysLoading &&
            ((zipCode || activeTab === activeTabs.location) || !isMultiLocation) &&
            appointmentTypeId
          }
        />

        {!!isMultiLocation && (
          <div style={{ width: '100%' }} className="tab-container">
            <Tabs
              onChange={(tab) => this.handleTabChange(tab.key)}
              aria-label="radius tab"
              style={{ width: '100%' }}
            >
              <Tab
                key="radius"
                title="Radius"
                default={activeTab === activeTabs.radius || !activeTab}
              >
                <div style={styles.container.sub_container}>
                  <div className="form-field-input zip">
                    <div
                      className={
                        zipCodeField.validationMessage ||
                        this.state.zipCodeMaskErrorMessage
                          ? 'control-group error'
                          : ''
                      }
                    >
                      <input
                        value={this.state.zipCode}
                        onChange={this.handleZipCodeChange}
                        onBlur={(e) =>
                          this.handleZipCodeValidation(true, e.target.value)
                        }
                        type={
                          this.state.country === countryList.US
                            ? 'number'
                            : 'text'
                        }
                        className="span30"
                        placeholder={`${this.state.zipCodePlaceHolder}`}
                        id={zipCodeField.uuid}
                        maxlength={
                          this.state.country === countryList.US
                            ? ZipCodeTextLength.US
                            : ZipCodeTextLength.CA
                        }
                        onInput={(e) =>
                          (e.target.value =
                            this.state.country === countryList.US
                              ? e.target.value.slice(0, 5)
                              : e.target.value)
                        }
                        onKeyPress={(e) =>
                          this.state.country === countryList.US &&
                          e.target.value.length === 5
                            ? e.preventDefault()
                            : null
                        }
                      />

                      <ValidationMessage
                        message={
                          zipCodeField.validationMessage ||
                          this.state.zipCodeMaskErrorMessage
                        }
                      />
                    </div>
                  </div>
                  <div className="slider">
                    <div className="slider-label">
                      <span style={{ fontWeight: 'normal' }}>
                        {Math.max(this.state.radiusSlider.maxRange, 0)} mi
                      </span>
                    </div>

                    <div className="form-field-input range">
                      <StyledSlider
                        min={this.state.radiusSlider.minRange}
                        max={this.state.radiusSlider.maxRange}
                        disabled={!this.isValidZipCode() || !isGeoLocationRequestCompleted}
                        step={SliderDefaultProp.steps}
                        value={this.state.radius}
                        onChangeCommitted={this.handleRadiusChange}
                        aria-labelledby="range-slider"
                        id={radiusField.uuid}
                        className="span30"
                        valueLabelDisplay={
                          this.state.radius !== this.state.radiusSlider.maxRange
                            ? 'on'
                            : 'off'
                        }
                      />

                      <ValidationMessage
                        message={radiusField.validationMessage}
                      />
                    </div>
                  </div>
                </div>
              </Tab>
              <Tab
                key="location"
                title="Location"
                default={activeTab === activeTabs.location}
              >
                <div className="location-container" style={{ width: '100%' }}>
                  <>
                    <MultiSelectWrapper
                      options={this.getMenuItems(filteredLocations)}
                      handleLocationChange={this.handleLocationChange}
                      listOfSelectedLocations={listOfSelectedLocations}
                      appointmentTypeId={appointmentTypeId}
                      selectedDay={selectedDay}
                      timeSlots={currentSelectedTimeSlots}
                      timeZone={timeZone}
                    />
                  </>
                </div>
              </Tab>
            </Tabs>
          </div>
        )}

        {isAvailProviderCoupled && (
          <div className={inputContainerClasses} style={styles.dropdownProvider}>
            <div className="form-field-label primary">{`${Labels.Provider} `}</div>
            <div className="form-field-input select">
              <select
                id={providerField.uuid}
                name="provider"
                className="span30"
                value={
                  this.state.isChangeAppointmentType ? 0 : providerField.value
                }
                onChange={this.handleProviderChange}
                disabled={readOnly || !appointmentTypeId}
              >
                {providers.map((p) => (
                  <option key={`provider-${p.id}`} value={p.id}>
                    {p.displayName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {(
          filteredLocations.length == 1 ||
          (filteredLocations.length > 1 && (activeTab !== activeTabs.radius || activeTab === activeTabs.radius && this.state.radius > 0))
        ) && (
          <>
            <LocationsList
              options={filteredLocations}
              timeSlots={currentSelectedTimeSlots}
              selectedDay={selectedDay}
              selectedTime={selectedTime}
              onTimeClick={this.handleTimeClick}
              timeSelectorField={timeSelectorField}
              readOnly={readOnly}
              handleLocationChange={this.handleLocationChange}
              isMultiLocation={isMultiLocation}
              listOfSelectedLocations={listOfSelectedLocations}
              activeTab={activeTab}
              noLocationFoundMessage={
                appointmentTypeId && activeTab == activeTabs.location
                  ? noLocationFoundMessageForAppointmentType
                  : locationNotFound
              }
              selectedProviderId={providerId}
              activePanels={activePanels}
              changeActivePanels={changeActivePanels}
              timeZone={timeZone}
            />

            {currentSelectedTimeSlots?.length > 0 && (
              <ValidationMessage
                message={timeSelectorField.validationMessage}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

const controls = {
  edit: false,
  delete: true,
  more: true
  // delete: __DEV__,
  // more: __DEV__,
};
export default FormFieldBase(
  FormFieldAppointmentBooking,
  controls,
  /* preventClick */ true
);

FormFieldAppointmentBooking.defaultProps = {
  isRenderedField: false,
  value: [],
  readOnly: false,
};
